/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Duration_1_HourInputs */

const en_duration_1_hour = /** @type {(inputs: Duration_1_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Hour`)
};

const es_duration_1_hour = /** @type {(inputs: Duration_1_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 hora`)
};

/**
* | output |
* | --- |
* | "1 Hour" |
*
* @param {Duration_1_HourInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const duration_1_hour = /** @type {((inputs?: Duration_1_HourInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duration_1_HourInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_duration_1_hour(inputs)
	return es_duration_1_hour(inputs)
});